import { createReducer, createSelector } from '@reduxjs/toolkit';
import { all, call, fork, takeEvery } from 'redux-saga/effects';
import {
  getAllGlobalContentTypesInitialize,
  getAllGlobalContentTypesSuccess,
} from '../actions/api';
import { GlobalContentTypeConnector } from '../connectors/globalContentTypeConnector';
import { getAttr } from '../helpers/apiHelpers';
import { updateDtoList } from '../helpers/reducerHelpers';
import { generateGetAllApiCall } from '../helpers/sagaHelpers';
import {
  getRequestData,
  selectAllFromApiState,
} from '../helpers/selectorHelpers';

// -------- Overview --------
// The following endpoints exist
//  - GET /globalContentType
//
// globalContentType is included in the following endpoints
//  - GET /globalContent/{typeId}/latest
//  - POST /globalContent/{typeId}

// -------- Reducer --------
const globalContentTypeReducer = createReducer(
  {
    all: [],
  },
  (builder) => {
    builder.addCase(getAllGlobalContentTypesSuccess, (state, action) => {
      const globalContentTypes = getRequestData(action);
      return updateDtoList(state, 'all', globalContentTypes);
    });
  },
);
// -------- Sagas ---------
export function* globalContentTypesSaga() {
  yield all([fork(getAllGlobalContentTypesSaga)]);
}

function* getAllGlobalContentTypesSaga() {
  yield takeEvery(
    getAllGlobalContentTypesInitialize.type,
    generateGetAllApiCall(GlobalContentTypeConnector, function* (connector) {
      return yield call([connector, connector.getGlobalContentTypes]);
    }),
  );
}

// -------- Selectors --------
const selectGetAllGlobalContentTypes = (state) =>
  selectAllFromApiState(state, 'globalContentType');

const allGlobalContentTypesSelector = createSelector(
  selectGetAllGlobalContentTypes,
  (globalContentTypes) => globalContentTypes,
);

const getGlobalContentTypeByTypeSelector = (globalContentTypeType) =>
  createSelector(allGlobalContentTypesSelector, (globalContentTypes) =>
    globalContentTypes.find(
      (globalContentType) =>
        getAttr(globalContentType, 'globalContentType') ===
        globalContentTypeType,
    ),
  );

export { allGlobalContentTypesSelector, getGlobalContentTypeByTypeSelector };
export default globalContentTypeReducer;
